import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { UserTrackStatuses } from '../../../constants/TracksConstants';
import { getTrackExamPageUrl } from '../../../utils/RoutingUtils';
import { useFullTrack } from '../../tracks';
import { useTrackProgressById, useTrackRedirectUrl } from '../../userProgress';

const useRedirectProgressedTrack = (trackId, language) => {
  const {
    trackProgressById,
    trackProgressByIdLoading,
    trackProgressByIdError
  } = useTrackProgressById(trackId);
  const {
    track,
    trackLoading,
    trackError
  } = useFullTrack(trackId, language);
  const {
    trackRedirectUrl,
    trackRedirectUrlLoading,
    trackRedirectUrlError
  } = useTrackRedirectUrl(trackId, language);
  const history = useHistory();
  useEffect(() => {
    if (trackProgressById && trackProgressById.status === UserTrackStatuses.COMPLETED && track && track.exam) {
      history.push(getTrackExamPageUrl(trackId.toString()));
    } else if (trackProgressById && trackProgressById.status === UserTrackStatuses.IN_PROGRESS && trackRedirectUrl) {
      history.push(trackRedirectUrl);
    }
  }, [history, trackProgressById, track, trackId, trackRedirectUrl]);
  return {
    redirectLoading: trackLoading || trackProgressByIdLoading || trackRedirectUrlLoading,
    redirectError: trackError || trackProgressByIdError || trackRedirectUrlError
  };
};

export default useRedirectProgressedTrack;